import { render } from "./MonthlySubscriptionView.vue?vue&type=template&id=635ec389&scoped=true"
import script from "./MonthlySubscriptionView.vue?vue&type=script&lang=js"
export * from "./MonthlySubscriptionView.vue?vue&type=script&lang=js"

import "./MonthlySubscriptionView.vue?vue&type=style&index=0&id=635ec389&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635ec389"]])

export default __exports__